import { useIntl } from '@capsicum/common';
import { GenericDrawer, useGoatImage } from '@capsicum/common-web';

export type DeleteRecipientModalProps = {
	onButtonPress: () => void;
	onSecondaryActionOnButtonPress: () => void;
	testID: string;
};

export const DeleteRecipientModal = ({
	onButtonPress,
	onSecondaryActionOnButtonPress,
	testID
}: DeleteRecipientModalProps) => {
	const { $t } = useIntl();
	const goatAnkwardImage = useGoatImage('ankward');

	const deleteRecipientDrawerData = {
		buttonText: $t('withdrawal.deleteRecipient.buttonText'),
		image: goatAnkwardImage,
		isButtonOnRow: false,
		onButtonPress,
		onSecondaryActionOnButtonPress,
		secondaryActionButtonText: $t('withdrawal.deleteRecipient.cancel'),
		testID: testID,
		title: $t('withdrawal.deleteRecipient.title')
	};

	return <GenericDrawer {...deleteRecipientDrawerData}></GenericDrawer>;
};
